/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:55:55
 *
 * LastModified: 2017-05-27 12:55:55
 *-------------------------------------------------------*/

function glassesDetail(state = {}, action) {
  switch (action.type) {
    case 'CLEAR_GLASSES_STATE':
      return {}
    case 'ADD_GLASSES_SUCCESS': {
      return action.payload
    }
    case 'GET_GLASSES_SUCCESS': {
      return action.payload
    }
    case 'EDIT_GLASSES_GENERAL_SUCCESS': {
      return {
        ...state,
        ...action.payload.product,
        locales: action.payload.locales,
        models: state.models,
      }
    }
    case 'CREATE_GLASSES_LOCALE_INFO_SUCCESS': {
      return {
        ...state,
        locales: [...state.locales, action.payload]
      }
    }
    case 'DELETE_GLASSES_LOCALE_INFO_SUCCESS': {
      const locales = state.locales
      const editLocaleInfoIdx = locales.findIndex(el => {
        return el.id === action.payload.id
      })
      if (editLocaleInfoIdx >= 0) {
        locales.splice(editLocaleInfoIdx, 1)
      }
      return {
        ...state,
        locales
      }
    }
    case 'CREATE_GLASSES_MODEL_SUCCESS': {
      return {
        ...state,
        models: [...state.models, action.payload]
      }
    }
    case 'EDIT_GLASSES_MODEL_SUCCESS': {
      const models = state.models
      const editModelIdx = models.findIndex(el => {
        return el.id === action.payload.id
      })
      if (editModelIdx >= 0) {
        models[editModelIdx] = action.payload
      }
      return {
        ...state,
        models
      }
    }
    case 'DELETE_GLASSES_MODEL_SUCCESS': {
      const models = state.models
      const editModelIdx = models.findIndex(el => {
        return el.id === action.payload.id
      })
      if (editModelIdx >= 0) {
        models.splice(editModelIdx, 1)
      }
      return {
        ...state,
        models
      }
    }
    default:
      return state
  }
}

export default glassesDetail



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-detail/reducer/index.js